/* tslint:disable */
/* eslint-disable */
/**
 * FanFair Complete API
 * Complete API documentation for FanFair platform including both public and private endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ChangeMerchantProcessingPlanRequest } from '../models';
// @ts-ignore
import type { CreateFiservApplicationRequest } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { FiservApplicationResponse } from '../models';
// @ts-ignore
import type { FiservProcessingPlansResponse } from '../models';
// @ts-ignore
import type { MerchantProcessingPlanResponse } from '../models';
/**
 * FiservBoardingApi - axios parameter creator
 * @export
 */
export const FiservBoardingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Resolves `planKey` against the live catalogue for the merchant\'s country and overwrites the binding snapshot from the catalogue definition. The plan change takes effect immediately for payments priced after it; FanFair sends no notification — contact FanFair Operations to have the matching change made in Forward. An unknown, unusable or wrong-country key is rejected with 400 `FISERV_PROCESSING_PLAN_NOT_FOUND` and the binding is unchanged. Re-sending the already-bound plan at the same rate is an idempotent no-op (200, nothing written, not audited); if the plan was repriced in the catalogue the stored rate is refreshed and audited. The caller must have access to the merchant (its partner, or a platform admin). 
         * @summary Change a merchant\'s bound Fiserv processing plan
         * @param {string} merchantId Merchant ID
         * @param {ChangeMerchantProcessingPlanRequest} changeMerchantProcessingPlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeMerchantProcessingPlanV1: async (merchantId: string, changeMerchantProcessingPlanRequest: ChangeMerchantProcessingPlanRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('changeMerchantProcessingPlanV1', 'merchantId', merchantId)
            // verify required parameter 'changeMerchantProcessingPlanRequest' is not null or undefined
            assertParamExists('changeMerchantProcessingPlanV1', 'changeMerchantProcessingPlanRequest', changeMerchantProcessingPlanRequest)
            const localVarPath = `/api/v1/merchants/{merchantId}/fiserv/processing-plan`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeMerchantProcessingPlanRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new Fiserv Forward boarding application for the specified merchant. Pre-fills the application with merchant data (business details, address, owner info) and returns a hosted application URL for the merchant to complete onboarding. 
         * @summary Create a Fiserv Forward boarding application for a merchant
         * @param {string} merchantId Merchant identifier
         * @param {CreateFiservApplicationRequest} [createFiservApplicationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFiservApplication: async (merchantId: string, createFiservApplicationRequest?: CreateFiservApplicationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('createFiservApplication', 'merchantId', merchantId)
            const localVarPath = `/api/v1/merchants/{merchantId}/fiserv/applications`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFiservApplicationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the merchant\'s Fiserv Forward boarding application and clears the merchant\'s processor record, so a fresh onboarding application can be created.  Only applications still in `DRAFT` or `CANCELLED` status can be deleted; any other status is rejected with `409` and nothing is changed. The status is read from Fiserv Forward at the time of the call, so an application that changed status since it was last displayed is also rejected — refresh the merchant and retry.  When the merchant was `ACTIVE` with this as its only processor, the merchant becomes `INACTIVE` and a `merchant.status.changed` webhook is emitted. 
         * @summary Delete a draft or cancelled Fiserv boarding application
         * @param {string} merchantId Merchant identifier
         * @param {string} applicationId Fiserv application identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFiservApplication: async (merchantId: string, applicationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('deleteFiservApplication', 'merchantId', merchantId)
            // verify required parameter 'applicationId' is not null or undefined
            assertParamExists('deleteFiservApplication', 'applicationId', applicationId)
            const localVarPath = `/api/v1/merchants/{merchantId}/fiserv/applications/{applicationId}`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"applicationId"}}`, encodeURIComponent(String(applicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the status and details of a Fiserv boarding application
         * @param {string} merchantId Merchant identifier
         * @param {string} applicationId Fiserv application identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiservApplication: async (merchantId: string, applicationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getFiservApplication', 'merchantId', merchantId)
            // verify required parameter 'applicationId' is not null or undefined
            assertParamExists('getFiservApplication', 'applicationId', applicationId)
            const localVarPath = `/api/v1/merchants/{merchantId}/fiserv/applications/{applicationId}`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"applicationId"}}`, encodeURIComponent(String(applicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reads the plan currently bound to the merchant\'s FISERV_FORWARD processor row, plus the persisted snapshot. `displayName` and `inCatalogue` are resolved against the live catalogue — a bound key no longer in the catalogue returns `inCatalogue: false` with `displayName: null`. An unbound row returns 200 with all binding fields null. 404 when the merchant does not exist or has no FISERV_FORWARD processor row. 503 `FISERV_PROCESSING_PLANS_UNAVAILABLE` when Forward\'s catalogue cannot be read. The caller must have access to the merchant (its partner, or a platform admin). 
         * @summary Get a merchant\'s bound Fiserv processing plan
         * @param {string} merchantId Merchant ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantProcessingPlanV1: async (merchantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getMerchantProcessingPlanV1', 'merchantId', merchantId)
            const localVarPath = `/api/v1/merchants/{merchantId}/fiserv/processing-plan`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the Fiserv Forward processing-plan catalogue — the plans a merchant can be boarded or bound to. Flat-rate plans that are active and priced consistently across card brands; inactive, interchange-plus or inconsistently-priced plans are excluded. Used to render the plan-selection dropdown when boarding a merchant or changing a merchant\'s plan. Supply `merchantId` to restrict the list to the plans that apply to that merchant\'s country; each entry carries its rate and per-transaction fee. 
         * @summary List the usable Fiserv Forward processing plans (catalogue)
         * @param {string} [merchantId] When supplied, only plans for this merchant\&#39;s country are returned. The caller must have access to the merchant (its partner, or a platform admin). 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFiservProcessingPlans: async (merchantId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/fiserv/processing-plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (merchantId !== undefined) {
                localVarQueryParameter['merchantId'] = merchantId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FiservBoardingApi - functional programming interface
 * @export
 */
export const FiservBoardingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FiservBoardingApiAxiosParamCreator(configuration)
    return {
        /**
         * Resolves `planKey` against the live catalogue for the merchant\'s country and overwrites the binding snapshot from the catalogue definition. The plan change takes effect immediately for payments priced after it; FanFair sends no notification — contact FanFair Operations to have the matching change made in Forward. An unknown, unusable or wrong-country key is rejected with 400 `FISERV_PROCESSING_PLAN_NOT_FOUND` and the binding is unchanged. Re-sending the already-bound plan at the same rate is an idempotent no-op (200, nothing written, not audited); if the plan was repriced in the catalogue the stored rate is refreshed and audited. The caller must have access to the merchant (its partner, or a platform admin). 
         * @summary Change a merchant\'s bound Fiserv processing plan
         * @param {string} merchantId Merchant ID
         * @param {ChangeMerchantProcessingPlanRequest} changeMerchantProcessingPlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeMerchantProcessingPlanV1(merchantId: string, changeMerchantProcessingPlanRequest: ChangeMerchantProcessingPlanRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantProcessingPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeMerchantProcessingPlanV1(merchantId, changeMerchantProcessingPlanRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FiservBoardingApi.changeMerchantProcessingPlanV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new Fiserv Forward boarding application for the specified merchant. Pre-fills the application with merchant data (business details, address, owner info) and returns a hosted application URL for the merchant to complete onboarding. 
         * @summary Create a Fiserv Forward boarding application for a merchant
         * @param {string} merchantId Merchant identifier
         * @param {CreateFiservApplicationRequest} [createFiservApplicationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFiservApplication(merchantId: string, createFiservApplicationRequest?: CreateFiservApplicationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FiservApplicationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFiservApplication(merchantId, createFiservApplicationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FiservBoardingApi.createFiservApplication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes the merchant\'s Fiserv Forward boarding application and clears the merchant\'s processor record, so a fresh onboarding application can be created.  Only applications still in `DRAFT` or `CANCELLED` status can be deleted; any other status is rejected with `409` and nothing is changed. The status is read from Fiserv Forward at the time of the call, so an application that changed status since it was last displayed is also rejected — refresh the merchant and retry.  When the merchant was `ACTIVE` with this as its only processor, the merchant becomes `INACTIVE` and a `merchant.status.changed` webhook is emitted. 
         * @summary Delete a draft or cancelled Fiserv boarding application
         * @param {string} merchantId Merchant identifier
         * @param {string} applicationId Fiserv application identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFiservApplication(merchantId: string, applicationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFiservApplication(merchantId, applicationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FiservBoardingApi.deleteFiservApplication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the status and details of a Fiserv boarding application
         * @param {string} merchantId Merchant identifier
         * @param {string} applicationId Fiserv application identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFiservApplication(merchantId: string, applicationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FiservApplicationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFiservApplication(merchantId, applicationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FiservBoardingApi.getFiservApplication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reads the plan currently bound to the merchant\'s FISERV_FORWARD processor row, plus the persisted snapshot. `displayName` and `inCatalogue` are resolved against the live catalogue — a bound key no longer in the catalogue returns `inCatalogue: false` with `displayName: null`. An unbound row returns 200 with all binding fields null. 404 when the merchant does not exist or has no FISERV_FORWARD processor row. 503 `FISERV_PROCESSING_PLANS_UNAVAILABLE` when Forward\'s catalogue cannot be read. The caller must have access to the merchant (its partner, or a platform admin). 
         * @summary Get a merchant\'s bound Fiserv processing plan
         * @param {string} merchantId Merchant ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantProcessingPlanV1(merchantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantProcessingPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantProcessingPlanV1(merchantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FiservBoardingApi.getMerchantProcessingPlanV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the Fiserv Forward processing-plan catalogue — the plans a merchant can be boarded or bound to. Flat-rate plans that are active and priced consistently across card brands; inactive, interchange-plus or inconsistently-priced plans are excluded. Used to render the plan-selection dropdown when boarding a merchant or changing a merchant\'s plan. Supply `merchantId` to restrict the list to the plans that apply to that merchant\'s country; each entry carries its rate and per-transaction fee. 
         * @summary List the usable Fiserv Forward processing plans (catalogue)
         * @param {string} [merchantId] When supplied, only plans for this merchant\&#39;s country are returned. The caller must have access to the merchant (its partner, or a platform admin). 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFiservProcessingPlans(merchantId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FiservProcessingPlansResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFiservProcessingPlans(merchantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FiservBoardingApi.listFiservProcessingPlans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FiservBoardingApi - factory interface
 * @export
 */
export const FiservBoardingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FiservBoardingApiFp(configuration)
    return {
        /**
         * Resolves `planKey` against the live catalogue for the merchant\'s country and overwrites the binding snapshot from the catalogue definition. The plan change takes effect immediately for payments priced after it; FanFair sends no notification — contact FanFair Operations to have the matching change made in Forward. An unknown, unusable or wrong-country key is rejected with 400 `FISERV_PROCESSING_PLAN_NOT_FOUND` and the binding is unchanged. Re-sending the already-bound plan at the same rate is an idempotent no-op (200, nothing written, not audited); if the plan was repriced in the catalogue the stored rate is refreshed and audited. The caller must have access to the merchant (its partner, or a platform admin). 
         * @summary Change a merchant\'s bound Fiserv processing plan
         * @param {string} merchantId Merchant ID
         * @param {ChangeMerchantProcessingPlanRequest} changeMerchantProcessingPlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeMerchantProcessingPlanV1(merchantId: string, changeMerchantProcessingPlanRequest: ChangeMerchantProcessingPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<MerchantProcessingPlanResponse> {
            return localVarFp.changeMerchantProcessingPlanV1(merchantId, changeMerchantProcessingPlanRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new Fiserv Forward boarding application for the specified merchant. Pre-fills the application with merchant data (business details, address, owner info) and returns a hosted application URL for the merchant to complete onboarding. 
         * @summary Create a Fiserv Forward boarding application for a merchant
         * @param {string} merchantId Merchant identifier
         * @param {CreateFiservApplicationRequest} [createFiservApplicationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFiservApplication(merchantId: string, createFiservApplicationRequest?: CreateFiservApplicationRequest, options?: RawAxiosRequestConfig): AxiosPromise<FiservApplicationResponse> {
            return localVarFp.createFiservApplication(merchantId, createFiservApplicationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the merchant\'s Fiserv Forward boarding application and clears the merchant\'s processor record, so a fresh onboarding application can be created.  Only applications still in `DRAFT` or `CANCELLED` status can be deleted; any other status is rejected with `409` and nothing is changed. The status is read from Fiserv Forward at the time of the call, so an application that changed status since it was last displayed is also rejected — refresh the merchant and retry.  When the merchant was `ACTIVE` with this as its only processor, the merchant becomes `INACTIVE` and a `merchant.status.changed` webhook is emitted. 
         * @summary Delete a draft or cancelled Fiserv boarding application
         * @param {string} merchantId Merchant identifier
         * @param {string} applicationId Fiserv application identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFiservApplication(merchantId: string, applicationId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteFiservApplication(merchantId, applicationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the status and details of a Fiserv boarding application
         * @param {string} merchantId Merchant identifier
         * @param {string} applicationId Fiserv application identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiservApplication(merchantId: string, applicationId: string, options?: RawAxiosRequestConfig): AxiosPromise<FiservApplicationResponse> {
            return localVarFp.getFiservApplication(merchantId, applicationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Reads the plan currently bound to the merchant\'s FISERV_FORWARD processor row, plus the persisted snapshot. `displayName` and `inCatalogue` are resolved against the live catalogue — a bound key no longer in the catalogue returns `inCatalogue: false` with `displayName: null`. An unbound row returns 200 with all binding fields null. 404 when the merchant does not exist or has no FISERV_FORWARD processor row. 503 `FISERV_PROCESSING_PLANS_UNAVAILABLE` when Forward\'s catalogue cannot be read. The caller must have access to the merchant (its partner, or a platform admin). 
         * @summary Get a merchant\'s bound Fiserv processing plan
         * @param {string} merchantId Merchant ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantProcessingPlanV1(merchantId: string, options?: RawAxiosRequestConfig): AxiosPromise<MerchantProcessingPlanResponse> {
            return localVarFp.getMerchantProcessingPlanV1(merchantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the Fiserv Forward processing-plan catalogue — the plans a merchant can be boarded or bound to. Flat-rate plans that are active and priced consistently across card brands; inactive, interchange-plus or inconsistently-priced plans are excluded. Used to render the plan-selection dropdown when boarding a merchant or changing a merchant\'s plan. Supply `merchantId` to restrict the list to the plans that apply to that merchant\'s country; each entry carries its rate and per-transaction fee. 
         * @summary List the usable Fiserv Forward processing plans (catalogue)
         * @param {string} [merchantId] When supplied, only plans for this merchant\&#39;s country are returned. The caller must have access to the merchant (its partner, or a platform admin). 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFiservProcessingPlans(merchantId?: string, options?: RawAxiosRequestConfig): AxiosPromise<FiservProcessingPlansResponse> {
            return localVarFp.listFiservProcessingPlans(merchantId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FiservBoardingApi - object-oriented interface
 * @export
 * @class FiservBoardingApi
 * @extends {BaseAPI}
 */
export class FiservBoardingApi extends BaseAPI {
    /**
     * Resolves `planKey` against the live catalogue for the merchant\'s country and overwrites the binding snapshot from the catalogue definition. The plan change takes effect immediately for payments priced after it; FanFair sends no notification — contact FanFair Operations to have the matching change made in Forward. An unknown, unusable or wrong-country key is rejected with 400 `FISERV_PROCESSING_PLAN_NOT_FOUND` and the binding is unchanged. Re-sending the already-bound plan at the same rate is an idempotent no-op (200, nothing written, not audited); if the plan was repriced in the catalogue the stored rate is refreshed and audited. The caller must have access to the merchant (its partner, or a platform admin). 
     * @summary Change a merchant\'s bound Fiserv processing plan
     * @param {string} merchantId Merchant ID
     * @param {ChangeMerchantProcessingPlanRequest} changeMerchantProcessingPlanRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiservBoardingApi
     */
    public changeMerchantProcessingPlanV1(merchantId: string, changeMerchantProcessingPlanRequest: ChangeMerchantProcessingPlanRequest, options?: RawAxiosRequestConfig) {
        return FiservBoardingApiFp(this.configuration).changeMerchantProcessingPlanV1(merchantId, changeMerchantProcessingPlanRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new Fiserv Forward boarding application for the specified merchant. Pre-fills the application with merchant data (business details, address, owner info) and returns a hosted application URL for the merchant to complete onboarding. 
     * @summary Create a Fiserv Forward boarding application for a merchant
     * @param {string} merchantId Merchant identifier
     * @param {CreateFiservApplicationRequest} [createFiservApplicationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiservBoardingApi
     */
    public createFiservApplication(merchantId: string, createFiservApplicationRequest?: CreateFiservApplicationRequest, options?: RawAxiosRequestConfig) {
        return FiservBoardingApiFp(this.configuration).createFiservApplication(merchantId, createFiservApplicationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes the merchant\'s Fiserv Forward boarding application and clears the merchant\'s processor record, so a fresh onboarding application can be created.  Only applications still in `DRAFT` or `CANCELLED` status can be deleted; any other status is rejected with `409` and nothing is changed. The status is read from Fiserv Forward at the time of the call, so an application that changed status since it was last displayed is also rejected — refresh the merchant and retry.  When the merchant was `ACTIVE` with this as its only processor, the merchant becomes `INACTIVE` and a `merchant.status.changed` webhook is emitted. 
     * @summary Delete a draft or cancelled Fiserv boarding application
     * @param {string} merchantId Merchant identifier
     * @param {string} applicationId Fiserv application identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiservBoardingApi
     */
    public deleteFiservApplication(merchantId: string, applicationId: string, options?: RawAxiosRequestConfig) {
        return FiservBoardingApiFp(this.configuration).deleteFiservApplication(merchantId, applicationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the status and details of a Fiserv boarding application
     * @param {string} merchantId Merchant identifier
     * @param {string} applicationId Fiserv application identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiservBoardingApi
     */
    public getFiservApplication(merchantId: string, applicationId: string, options?: RawAxiosRequestConfig) {
        return FiservBoardingApiFp(this.configuration).getFiservApplication(merchantId, applicationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reads the plan currently bound to the merchant\'s FISERV_FORWARD processor row, plus the persisted snapshot. `displayName` and `inCatalogue` are resolved against the live catalogue — a bound key no longer in the catalogue returns `inCatalogue: false` with `displayName: null`. An unbound row returns 200 with all binding fields null. 404 when the merchant does not exist or has no FISERV_FORWARD processor row. 503 `FISERV_PROCESSING_PLANS_UNAVAILABLE` when Forward\'s catalogue cannot be read. The caller must have access to the merchant (its partner, or a platform admin). 
     * @summary Get a merchant\'s bound Fiserv processing plan
     * @param {string} merchantId Merchant ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiservBoardingApi
     */
    public getMerchantProcessingPlanV1(merchantId: string, options?: RawAxiosRequestConfig) {
        return FiservBoardingApiFp(this.configuration).getMerchantProcessingPlanV1(merchantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the Fiserv Forward processing-plan catalogue — the plans a merchant can be boarded or bound to. Flat-rate plans that are active and priced consistently across card brands; inactive, interchange-plus or inconsistently-priced plans are excluded. Used to render the plan-selection dropdown when boarding a merchant or changing a merchant\'s plan. Supply `merchantId` to restrict the list to the plans that apply to that merchant\'s country; each entry carries its rate and per-transaction fee. 
     * @summary List the usable Fiserv Forward processing plans (catalogue)
     * @param {string} [merchantId] When supplied, only plans for this merchant\&#39;s country are returned. The caller must have access to the merchant (its partner, or a platform admin). 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiservBoardingApi
     */
    public listFiservProcessingPlans(merchantId?: string, options?: RawAxiosRequestConfig) {
        return FiservBoardingApiFp(this.configuration).listFiservProcessingPlans(merchantId, options).then((request) => request(this.axios, this.basePath));
    }
}

